<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.mint"
        placeholder="代币地址"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.user_address"
        placeholder="用户地址"
        style="width: 220px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="用户地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.user? scope.row.user.address:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="代币地址" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.mint }}
        </template>
      </el-table-column>

      <el-table-column label="代币名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.token?scope.row.token.name:"-"}}
        </template>
      </el-table-column>

      <el-table-column label="内容" min-width="280" align="center">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>

      <el-table-column label="时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        width="180"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleDel(scope.row.id)"
            style="width: 80px"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/comment/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/admin/comment/delete',
          method: 'post',
          data: {id: val}
        }).then(()=>{
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
.box-card {
  text-align: center;
  .value {
    font-size: 26px;
    margin-top: 20px;
    color: gray;
  }
  .title {
    font-size: 20px;
    color: black;
    font-weight: bold;
  }
  .subtitle {
    font-size: 12px;
    color: gray;
  }
}
</style>
